import { render, staticRenderFns } from "./IconSnoozeExclusive.vue?vue&type=template&id=3d8decc8&scoped=true&"
var script = {}
import style0 from "./IconSnoozeExclusive.vue?vue&type=style&index=0&id=3d8decc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8decc8",
  null
  
)

export default component.exports